import { useEffect } from 'react';

const sourceId = 'ot-sdk-cookie-policy';
const copyId = 'ot-sdk-cookie-policy-copy';

// OneTrust renders the cookie policy only once, when it initializes, so render
// it again when the placeholder mounts (e.g. after client-side navigation) and
// mirror it into the extra copies (the Portuguese section of the policy).
export function useCopyOneTrustCookiePolicy() {
  useEffect(() => {
    const source = document.getElementById(sourceId);
    const targets = Array.from(
      document.querySelectorAll<HTMLElement>(`#${copyId}`)
    );
    if (!source || targets.length === 0) return;

    const copy = () => {
      if (!source.innerHTML) return;
      targets.forEach((target) => {
        target.innerHTML = source.innerHTML;
      });
    };

    const oneTrust = window.OneTrust;
    if (!source.innerHTML && oneTrust?.initializeCookiePolicyHtml) {
      oneTrust.initializeCookiePolicyHtml();
    }

    copy();
    const observer = new MutationObserver(copy);
    observer.observe(source, { childList: true, subtree: true });
    return () => observer.disconnect();
  }, []);
}
